import React from "react";
import {formatFulfillmentStatus} from "../../lib/FulfillmentStatus";
import Checked from "./icons/Checked";
import Error from "./icons/Error";
import styles from "./StatusWithIcon.module.scss";


// We want to apply green/red colours to good/bad statuses
// as well as appropriate icons.
export const StatusWithIcon = (props) => {
  const {
    status,
    side = "18px",
  } = props;

  const formattedStatus = formatFulfillmentStatus(status);

  const iconsCommonProps = {
    side: side,
  }
  const classes = [
    styles.module,
  ];

  switch (status) {
    case "delivered":
      classes.push(styles.positive);
      return (
        <span className={classes.join(" ")}>
          <Checked {...iconsCommonProps} /> {formattedStatus}
        </span>
      );

    case "failed":
    case "exception":
      classes.push(styles.negative);
      return (
        <span className={classes.join(" ")}>
          {<Error {...iconsCommonProps} />} {formattedStatus}
        </span>
      );
    
    default:
      return (
        <span className={styles.module}>
          {formattedStatus}
        </span>
      );
  }
}